/* eslint-disable no-plusplus */
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Button2 from 'components/buttons/Button2/Button2';
import styles from './style.cssmodule.css';
import { ParkingsContext } from '../../contexts/ParkingsContext';

function TableFooter() {
  const { formatMessage: t } = useIntl();
  const {
    pageNumber, totalEntries, totalPages, setPage,
  } = useContext(ParkingsContext);

  return (
    <div className={styles.tableFooter}>
      <div className={styles.results}>
        {t({ id: 'info.resultsDisplayed' }, { nbResults: totalEntries, pageBegin: pageNumber, pageEnd: totalPages })}
      </div>
      {totalPages > 1 ? (
        <div className={styles.pagesButtonsContainer}>
          <Button2
            type="secondaryOutline"
            size="small"
            onClick={() => {
              setPage(pageNumber - 1);
              scrollSmoothToTop();
            }}
            disabled={pageNumber === 1}
          >
            {t({ id: 'button.previousPage' })}
          </Button2>
          <Button2
            type="secondaryOutline"
            size="small"
            onClick={() => {
              setPage(pageNumber + 1);
              scrollSmoothToTop();
            }}
            disabled={pageNumber === totalPages}
          >
            {t({ id: 'button.nextPage' })}
          </Button2>
        </div>
      ) : null}
    </div>
  );
}

function scrollSmoothToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // Optional for smooth scrolling
  });
}

export default TableFooter;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/TableFooter/TableFooter.jsx